import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { FormGroup, InputGroup, H2, H4, H6, HTMLSelect, Icon } from '@blueprintjs/core';
import { TablePagination, Paper } from '@material-ui/core';
import Chart from 'react-apexcharts';
import MaterialTable from 'material-table';
import { estimatedClass } from '../common';
import { rounded }  from '../../../utils.js';
//import { PUBLIC_URL, ANALYTICS_URL } from '../../../constants';
import Cookies from 'js-cookie';
import { FRONT_USER_LANG_COOKIE_NAME } from '../../../auth/constants';

import './Chrono.css';

class ChronoOccsByRealization extends React.PureComponent {

  state = {
    displayType: 'freq', // 'specByTimeId'
    currentReal: this.props.data.occsByRealization? Object.keys(this.props.data.occsByRealization)[0]:"",
    nbRealToDisplay: 5,
    filter:"",
    height:300,
  }

  initChart=()=> {
    this.setState({ height: 350 });
  }

  onTypeChange = (e) => {
    e.preventDefault();
    this.setState({ displayType: e.target.value });
  }
  onFilterChange = (e) => {
    e.preventDefault();
    this.setState({ filter: e.target.value });
  }
  onNbestChange = (e) => {
    e.preventDefault();
    this.setState({ nbRealToDisplay: e.target.value });
  }
  onRealChange = (e) => {
    e.preventDefault();
    this.setState({ currentReal: e.target.value });
  }



  render() {
    const { stats, warningIncompleteExtraction, t } = this.props;
    const langFormat = Cookies.get(FRONT_USER_LANG_COOKIE_NAME)==="en"? "en-EN":"fr-FR";
    
    const data=this.props.data.occsByRealization;
    const increasingReals=this.props.data.increasingReals;
    const decreasingReals=this.props.data.decreasingReals;
    const incDecReals=this.props.data.incDecReals;
    const decIncReals=this.props.data.decIncReals;
    const labels={
      'freq': t('frequency'),
      'relFreq':t('relFrequency'),      
      'cumu':t('cumFrequency'),
      'spec':t('specificity'),
      'timeSpec':t('timeSpecificity'),
      'size':t('timeSpanSize'),
    };
    var filterVal=this.state.filter;
    const type = this.state.displayType ;
    const typeLabel=labels[type];
    const typeLabelLower = typeLabel.toLowerCase();
    const currentReal=data[this.state.currentReal]? 
      this.state.currentReal:
      Object.keys(data)[0];
    const disp = data[currentReal].length;
    // data was previously a table of 6-uplets  [num,timeId,freqInTimeId,FreqGlobal,sizeOfTimeId,SizeGlobal]
    // then transformated into object {timeId,freq,spec}

    // constructing table element
    const table = (
      <MaterialTable
        columns={[
          { title: t('timeId'), field: 'timeId' },
          { title: typeLabel, field: type, render: rowData => <span className={estimatedClass(rowData[type],warningIncompleteExtraction)}>{rounded(rowData[type])}</span> },
        ]}
        data={data[currentReal]}
        title={typeLabel}
        options={{
          filtering: true,
          search: true,
          sorting: true,
          exportButton: true,
          exportFileName:typeLabelLower,
          exportAllData: true,
        }}
        components={{
          Pagination: props => (
            <TablePagination
              {...props}
              rowsPerPageOptions={[10, 25, 50, 100, data[currentReal].length]}
            />
          ),
          Container: props => (
            <Paper
              {...props}
              elevation={0}
            />
          ),
        }}
      />
    );

    // prep data for the chart : realizations are sorted by decreasing overall frequency
    
    const realizations=Object.keys(data).sort((a,b)=> stats.realizations[b].freq - stats.realizations[a].freq);
    const filteredRealizations=this.state.filter !== "" ? realizations.filter( (real)=> real.match(RegExp(filterVal))):realizations;
    const series=[];
    const selectOptions= realizations.map ( (realization) =>  
        <option key={realization} value={realization}>{realization}</option>
    );

    for (var j=0;j<filteredRealizations.length && j< this.state.nbRealToDisplay;j++) {
        const xyTab=[];
        var realization=filteredRealizations[j];
        if (data[realization] && data[realization].length>0) {
          // time format computation
          const k=data[realization][0].timeId.split("-")[0].split("/");
          var dateFormat=(k===3)? "yyyy MMM dd" : (k===2) ? "yyyy MMM" : "yyyy";
          for (var i=0;i<data[realization].length;i++) {
              const point=data[realization][i];
              const timeId=point.timeId.split("-")[0];
              const ymd=timeId.split( "/");
              const year=ymd[0];
              const month=ymd[1]?ymd[1]:1;
              const day=ymd[2]?ymd[2]:1;
              const val= point[type];
              xyTab.push(
                  { x: new Date(year,month,day).getTime(),
                    y: val
                  }
              );
          }
          series.push({ 
              name:realization,
              data:xyTab
          });
        }
    }

    // prep data for the single realization chart
    const xyTab=[];
    const serie=[];
    realization=currentReal;

    for ( i=0;i<data[realization].length;i++) {
        const point=data[realization][i];
        const timeId=point.timeId.split("-")[0];
        const ymd=timeId.split( "/");
        const year=ymd[0];
        const month=ymd[1]?ymd[1]:1;
        const day=ymd[2]?ymd[2]:1;
        const val= point[type];
        xyTab.push(
            { x: new Date(year,month,day).getTime(),
              y: val
            }
        );
    }
    serie.push({ 
        name:realization,
        data:xyTab
    });

    const options = {
        chart: {
        type: 'line',
        //height: 350
        },
        dataLabels: {
            enabled: false,
        },
        legend: {
          position :'top'
        },        
        tooltip: {
            enabled:true,
            x: {
                show: true,
                format: dateFormat,
                formatter: undefined,
            },
        },
        yaxis: {
            title: {
                text: t(typeLabel),
            },
            labels: {
                formatter: function (y) {
                return rounded(y,2)
                }
            }
        },
        xaxis: {
            type: 'datetime',
            //categories: xTab,
            labels: {
                rotate: -90,
                //datetimeFormatter: {
                //year: 'yyyy',
                //month: "MMM 'yy",
                //day: 'dd MMM',
                //hour: 'HH:mm',
                //},
            },
            
        }
    };

    const increasingRealsList=Object.keys(increasingReals).sort( (a,b)=>  increasingReals[b].coeff-increasingReals[a].coeff).map( real =>
      <li key={real}>
         {real} : {t('firstAttestation')}= {increasingReals[real].firstAttestation} (freq= {increasingReals[real].freq}, coeff= {increasingReals[real].coeff})
      </li>
    );
    const decreasingRealsList=Object.keys(decreasingReals).sort( (a,b)=> decreasingReals[b].coeff-decreasingReals[a].coeff).map( real =>
      <li key={real}>
         {real} : {t('lastAttestation')}= {decreasingReals[real].lastAttestation} (freq= {decreasingReals[real].freq}, coeff= {decreasingReals[real].coeff})
      </li>
    );
    const incDecRealsList=Object.keys(incDecReals).sort( (a,b)=>  incDecReals[b].coeff-incDecReals[a].coeff).map( real =>
      <li key={real}>
         {real} (freq= {incDecReals[real].freq}, coeff= {incDecReals[real].coeff})
      </li>
    );
    const decIncRealsList=Object.keys(decIncReals).sort( (a,b)=> decIncReals[b].coeff-decIncReals[a].coeff).map( real =>
      <li key={real}>
         {real} (freq= {decIncReals[real].freq}, coeff= {decIncReals[real].coeff})
      </li>
    );

    return(
    <>
      { data[currentReal].length>0 && 
        <Paper className="margin-bottom-1-5-rem padding-1-rem">
        <H2>{t('searchResults')}</H2>

        <div className="margin-bottom-1-5-rem">
          <H4><u>{t('detailedStats')}</u></H4>
          <FormGroup label={t('type')} labelFor='type' inline={true}>
          <HTMLSelect id='type' name='type' onChange={this.onTypeChange}>
              <option value='freq'>{t('freqByTimeId')}</option>
              <option value='relFreq'>{t('relFrequency')}</option>
              <option value='cumu'>{t('cumFreqByTimeId')}</option>
              <option value='spec'>{t('specByTimeId')}</option>
              <option value='timeSpec'>{t('timeSpecByTimeId')}</option>
              <option value='size'>{t('timeSpanSize')}</option>
            </HTMLSelect>
          </FormGroup>
        </div>

        <div className="margin-bottom-1-rem">
          <H6><u>{t('evolutionForMoreFrequentReal')}</u></H6>
          <FormGroup
            helperText={t('filterUsingRegex')}
            inline={true}
            label={t('filter')}
          >
            <InputGroup
              value={filterVal}
              disabled={false}
              onChange={this.onFilterChange}
            />
          </FormGroup>
          <FormGroup label={t('nBest')} labelFor='type' inline={true}>
            <HTMLSelect id='nbest' name='nbest' onChange={this.onNbestChange}>
              <option value='5'>5</option>
              <option value='6'>6</option>
              <option value='7'>7</option>
              <option value='8'>8</option>
              <option value='9'>9</option>
              <option value='10'>10</option>
              <option value='15'>15</option>
              <option value='20'>20</option>
            </HTMLSelect>
          </FormGroup>
          <br/>
          <br/>
          
          <div id="chartOccsByReal" onClick={this.initChart} >
             { series.length>0 &&
              <Chart options={options} series={series} height={this.state.height} />
             }
          </div>
        </div>

        <div className="margin-bottom-1-5-rem">
          <p>{t('coeffExplanation')}</p>

          { increasingRealsList.length>0 &&
            <>
              <H4><u>{t('increasingReals')}</u> <Icon icon='trending-up'/></H4>
              <ul>
                {increasingRealsList}
              </ul>
            </>
          }
          { decreasingRealsList.length>0 &&
            <>
              <H4><u>{t('decreasingReals')}</u> <Icon icon='trending-down'/></H4>
              <ul>
                {decreasingRealsList}
              </ul>
            </>
          }
          { incDecRealsList.length>0 &&
            <>
              <H4><u>{t('incDecReals')}</u> <Icon icon='trending-up'/><Icon icon='trending-down'/></H4>
              <ul>
                {incDecRealsList}
              </ul>
            </>
          }
          { decIncRealsList.length>0 &&
            <>
              <H4><u>{t('decIncReals')}</u> <Icon icon='trending-down'/><Icon icon='trending-up'/></H4>
              <ul>
                {decIncRealsList}
              </ul>
            </>
          }          

        </div>

        <div className="margin-bottom-1-5-rem">
          <H4><u>{t('choseRealization')}</u></H4>
          <FormGroup label={t('realization')} labelFor='realization' inline={true}>
            <HTMLSelect id='realization' name='realization' onChange={this.onRealChange}>
                {selectOptions}
            </HTMLSelect>
          </FormGroup>
          <br/>
          <br/>
          <div id="chart" onClick={this.initChart}>
             <Chart options={options} series={serie}  height={this.state.height} />
          </div>
        </div>

        <div className="margin-bottom-1-rem">
          <H4><u>{t('nbTimeSpan')} - {currentReal}</u></H4>
          <ul>
             <li>{t('beginningColon')} {data[currentReal][0].timeId}</li>
             <li>{t('endingColon')} {data[currentReal][disp-1].timeId}</li>
             <li>{t('dispColon')} {Intl.NumberFormat(langFormat).format(disp)}</li>
          </ul>
          
        </div>

        <H6><u>{t('completeResList')}</u></H6>
          {table}
        </Paper>
      }
    </>
    );
  }

}

ChronoOccsByRealization.propTypes = {
  data: PropTypes.object,
  stats: PropTypes.object,
  warningIncompleteExtraction: PropTypes.bool,
};

export default withTranslation()(ChronoOccsByRealization);
